/**
 * Returns the basepath of the given url
 * @module basepath
 * @category url
 * @param {string} url - The url
 */
export default function basepath(url){
    return url.substring(0, url.lastIndexOf('/')+1).trim();
};
export { basepath };